export const GET_APP_DATA_REQUEST = 'data/GET_APP_DATA_REQUEST'
export const GET_APP_DATA_ERROR = 'data/GET_APP_DATA_ERROR'
export const GET_APP_DATA_SUCCESS = 'data/GET_APP_DATA_SUCCESS'

/* ------------- Orders ------------- */
export const POST_ORDERS_MULTISIM = 'orders/POST_ORDERS_MULTISIM'
export const POST_ORDERS_MULTISIM_SUCCESS = 'orders/POST_ORDERS_MULTISIM_SUCCESS'
export const POST_ORDERS_MULTISIM_ERROR = 'orders/POST_ORDERS_MULTISIM_ERROR'

export const PATCH_ORDERS_MULTISIM_ORDER_ID = 'orders/PATCH_ORDERS_MULTISIM_ORDER_ID'
export const PATCH_ORDERS_MULTISIM_ORDER_ID_SUCCESS = 'orders/PATCH_ORDERS_MULTISIM_ORDER_ID_SUCCESS'
export const PATCH_ORDERS_MULTISIM_ORDER_ID_ERROR = 'orders/PATCH_ORDERS_MULTISIM_ORDER_ID_ERROR'
